import { createFileRoute } from '@tanstack/react-router';
import { ProdutoList } from '@/features/produto/page/list/ProdutoList';

export const Route = createFileRoute('/a/produto/')({
    component: ProdutoList,
});
